import { memo, useId } from "react";
interface RatingScoreObjectsRightProps {
  /** 渐变类型 */
  variant?: "A" | "B" | "C" | "D";
  /** 自定义样式类名 */
  className?: string;
  /** 左右装饰宽度（px），用于适配不同版式 */
  width?: number;
  /** 左右装饰高度（px），用于适配不同版式 */
  height?: number;
}

/**
 * RatingScoreObjectsRight - 评级分数左侧装饰图标组件
 * 支持四种不同的渐变变体（A/B/C/D）
 */
const RatingScoreObjectsRight = memo(
  ({
    variant = "A",
    className,
    width,
    height,
  }: RatingScoreObjectsRightProps) => {
    const uid = useId();
    // 根据变体获取渐变配置
    const gradientConfig = {
      A: {
        id: "rating-gradient-A",
        stops: [
          { offset: "0%", color: "#9D7103", opacity: 0.5 },
          { offset: "100%", color: "#A87900", opacity: 1 },
        ],
        fillOpacity: 0.5,
        x1: "19.9846",
        y1: "3.69577",
        x2: "18.2067",
        y2: "65.121",
      },
      B: {
        id: "rating-gradient-B",
        stops: [
          { offset: "0%", color: "#BCB7B7", opacity: 0.5 },
          { offset: "100%", color: "#606060", opacity: 1 },
        ],
        fillOpacity: 0.5,
        x1: "19.9845",
        y1: "3.69571",
        x2: "18.2066",
        y2: "65.1201",
      },
      C: {
        id: "rating-gradient-C",
        stops: [
          { offset: "0%", color: "#CF814C", opacity: 0.5 },
          { offset: "100%", color: "#CF814C", opacity: 1 },
        ],
        fillOpacity: 0.5,
        x1: "19.9845",
        y1: "3.69571",
        x2: "18.2066",
        y2: "65.1201",
      },
      D: {
        id: "rating-gradient-D",
        stops: [
          { offset: "0%", color: "#8C8C8C", opacity: 0.5 },
          { offset: "100%", color: "#8C8C8C", opacity: 1 },
        ],
        fillOpacity: 0.2,
        x1: "19.9842",
        y1: "3.69571",
        x2: "18.2064",
        y2: "65.12",
      },
    };

    const config = gradientConfig[variant];
    const gradientId = `${config.id}-${uid}`;
    const clipPathId = `clip0_rating_${variant}-${uid}`;

    const pathABCD =
      "M11.2705 62.4043C12.662 62.169 13.8861 61.8943 15.3096 62.208C18.1724 62.8435 20.259 65.6045 21.5625 67.6201V67.6279C21.6904 67.8318 21.635 67.9803 21.4512 67.9961C21.1233 68.0275 20.435 66.4909 19.8672 65.832C18.8275 64.632 18.084 64.5219 17.2363 64.6631C16.7646 64.7415 16.069 64.9375 15.3096 65.5332C14.374 66.2625 13.3502 66.5292 12.3906 66.2549C9.2569 65.3734 8.62206 62.1262 8.61523 62.0908C8.62016 62.095 9.36558 62.7248 11.2705 62.4043ZM16.0244 54.5127C16.0362 54.524 18.0413 56.4475 18.7988 58.1836C19.2547 59.2267 19.2395 60.9368 19.3115 62.1133C19.3678 63.0782 20.2627 65.1172 20.2627 65.1172C20.2627 65.1172 19.7587 64.6308 18.7832 63.6191C17.8075 62.6074 16.3759 60.9988 16.168 60.0498C15.7522 58.1596 16.2803 55.4774 16.0244 54.5127ZM3.62305 54.1885C4.65478 55.4354 7.74125 55.2319 9.64453 55.8672C11.5151 56.4993 14.5059 59.8808 14.6084 59.9971C14.4813 59.9693 13.2352 59.71 12.3633 60C11.2277 60.3764 9.5488 60.596 8.10938 59.9844C4.41466 58.4079 3.62305 54.1885 3.62305 54.1885ZM14.6191 60H14.6104C14.6099 59.9995 14.6095 59.9983 14.6084 59.9971C14.6154 59.9986 14.6191 60 14.6191 60ZM12.5791 48.1182C12.5996 48.1462 14.4125 50.6314 14.834 52.6201C15.0898 53.8201 14.6579 55.6708 14.458 56.9805C14.2908 58.0423 14.8533 59.4774 14.8584 59.4902H14.8506C14.8506 59.4902 11.4277 56.2672 11.4033 54.1104C11.3793 51.9537 12.6348 49.2164 12.5791 48.1182ZM0.981445 44.3594C1.54928 46.0847 4.16369 45.7636 5.78711 47.3164C7.40568 48.8569 9.31086 53.3675 9.32227 53.3945V53.4023C9.31228 53.3951 8.13458 52.539 7.16309 52.375C5.97151 52.1711 3.876 52.2732 2.86035 50.8223C1.16494 48.3909 0.981445 44.3594 0.981445 44.3594ZM9.68457 53.0557V53.0635C9.68439 53.0623 9.68344 53.0587 9.68262 53.0527C9.68352 53.0543 9.6843 53.0552 9.68457 53.0557ZM10.9316 42.209C10.9316 42.209 11.6916 43.8173 11.5156 45.833C11.4115 47.0407 10.4602 48.7423 9.8125 50.5459C9.47825 51.4846 9.66321 52.9121 9.68262 53.0527C9.60797 52.9245 7.41466 49.1323 7.97266 47.1816C8.54045 45.1895 10.6837 43.26 10.9316 42.209ZM0.0546875 33.9072C0.326902 35.7815 2.68513 36.9738 4.06055 38.9736C5.43607 40.9658 6.78027 45.915 6.78027 45.915V45.9229C6.78027 45.9229 5.70065 44.7694 4.74902 44.3301C3.58143 43.7967 1.81339 42.7539 1.01367 41.0127C-0.314509 38.1188 0.0506708 33.9526 0.0546875 33.9072ZM10.1162 34.5547C10.1162 34.5547 10.6758 37.9591 10.2119 39.9355C9.93193 41.1198 8.71691 42.4065 7.94922 43.3633C7.31754 44.1398 7.20508 45.6924 7.20508 45.6924H7.19727C7.19727 45.6924 5.41417 40.7047 6.35742 38.8691C7.30109 37.0338 9.66837 35.5508 10.1162 34.5547ZM10.8896 27.998C10.8901 28.0066 10.9834 29.8224 10.0898 31.6299C9.55393 32.712 8.0667 33.9118 6.81934 35.3232C6.14614 36.0922 5.78618 37.5845 5.7793 37.6133C5.77236 37.5633 5.14646 33.025 6.37891 31.4102C7.62647 29.7866 10.2739 28.8843 10.8896 27.998ZM1.93066 24.8135C1.65128 26.6564 4.1459 28.4603 4.84961 30.6719C5.54977 32.8801 5.32362 37.231 5.32129 37.2754C5.30407 37.2457 4.45035 35.7793 3.69043 35.1426C2.74683 34.3505 0.891156 33.3779 0.666992 31.5586C0.285633 28.5353 1.90944 24.8613 1.93066 24.8135ZM6.00488 29.165L5.99707 29.1729C5.99745 29.1718 5.99838 29.1656 6.00195 29.1553C6.00344 29.161 6.00469 29.1643 6.00488 29.165ZM6.45996 29.1729V29.165C6.46018 29.1647 6.46011 29.1634 6.46094 29.1621C6.46008 29.168 6.46013 29.1717 6.45996 29.1729ZM13.4658 20.6553C13.4658 20.6553 12.5945 24.2401 11.291 25.7617C10.5074 26.6714 9.25962 27.0481 8.16406 27.4873C7.29216 27.8385 6.50221 29.0955 6.46094 29.1621C6.5001 28.8923 7.26326 23.7703 8.85938 22.6631C10.4988 21.5259 12.6261 21.3062 13.4658 20.6553ZM4.55762 16.4668C3.93387 18.2863 6.461 20.2472 6.95703 22.498C7.47285 24.8462 6.10466 28.8591 6.00195 29.1553C5.96689 29.0195 5.57642 27.5394 4.98926 26.6943C4.23751 25.6121 2.98253 24.4983 2.7666 22.1143C2.46271 18.8594 4.55762 16.4668 4.55762 16.4668ZM16.4102 13.126C16.4102 13.126 15.2825 16.303 14.1309 17.7227C13.4431 18.5775 11.5872 19.2204 10.6436 19.5498C9.87248 19.8228 9.18869 21.0182 9.18066 21.0322V21.0244C9.18066 21.0244 9.85177 15.8398 11.2832 14.8828C12.7147 13.926 15.6504 13.7064 16.4102 13.126ZM8.2666 7.72852C7.74678 9.36773 9.39453 11.4309 9.69043 13.8701C9.98615 16.3094 8.44238 20.6621 8.44238 20.6621C8.4399 20.6562 7.8977 19.3736 7.32324 18.4189C6.61955 17.2426 6.05137 15.972 6.11523 14.082C6.22695 10.9359 8.25779 7.74236 8.2666 7.72852ZM14.7002 1.95117C13.9567 2.97117 13.5972 5.96638 13.1895 7.89551C12.7835 9.82389 10.721 13.0815 10.7021 13.1113C10.7044 13.0926 10.8689 11.7169 10.7021 10.7666C10.4942 9.59013 10.3023 7.71526 10.8301 6.3584C11.7035 4.1004 14.6575 1.98168 14.7002 1.95117ZM19.0273 8.07812C19.0131 8.11349 17.8626 10.9543 15.7646 11.8975C15.077 12.2112 14.3089 12.0462 13.4453 12.2344C12.2777 12.4854 11.3574 12.9639 11.3574 12.9639C11.3574 12.9639 12.6138 9.55265 14.4932 9.07422C15.8687 8.72914 18.2757 8.37614 19.0273 8.07812ZM14.4248 7.88477H14.416C14.4196 7.88232 14.4231 7.87939 14.4268 7.87695C14.4254 7.88125 14.4251 7.88398 14.4248 7.88477ZM22.9971 0.00292969C22.9677 0.0292954 21.073 1.7363 19.3828 4.73242C18.3532 6.56372 16.1921 6.68386 14.4268 7.87695C14.4925 7.67056 15.8396 3.48811 17.3838 2.06543C19.7862 -0.150114 22.9637 0.00127604 22.9971 0.00292969Z";

    // 根据变体选择路径和视图框
    const svgPath = pathABCD;
    const viewBox = "0 0 23 68";
    const svgWidth = width ?? 23;
    const svgHeight = height ?? 68;

    return (
      <svg
        width={svgWidth}
        height={svgHeight}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <defs>
          {/* 自定义渐变 */}
          <linearGradient
            id={gradientId}
            x1={config.x1}
            y1={config.y1}
            x2={config.x2}
            y2={config.y2}
            gradientUnits="userSpaceOnUse"
          >
            {config.stops.map((stop, index) => (
              <stop
                key={index}
                offset={stop.offset}
                stopColor={stop.color}
                stopOpacity={stop.opacity}
              />
            ))}
          </linearGradient>
          {/* ClipPath */}
          <clipPath id={clipPathId}>
            <rect width="23" height="68" fill="white" />
          </clipPath>
        </defs>
        <g clipPath={`url(#${clipPathId})`}>
          <path
            d={svgPath}
            fill={`url(#${gradientId})`}
            fillOpacity={config.fillOpacity}
          />
        </g>
      </svg>
    );
  },
);

RatingScoreObjectsRight.displayName = "RatingScoreObjectsRight";

export { RatingScoreObjectsRight };
